/**
 *  Main
 *
 *  Created by Legman on 20/03/2017.
 *
 */

import Application              from "./Application";
import AudioManager             from "./AudioManager";
import BoomerangPreloaderScene  from "./scenes/BoomerangPreloaderScene";
import Common                   from "./Common";
import Input                    from "./Input";

export default class Main {
    /**
     * @param {number} width
     * @param {number} height
     */
    constructor(width, height) {
        /**
         * @member {!number}
         * @private
         */
        this._width = width;

        /**
         * @member {!number}
         * @private
         */
        this._height = height;

        /**
         * @member {BoomerangPreloaderScene}
         * @private
         */
        this._preloader = null;

        /**
         * @member {Application}
         * @private
         */
        this._game = null;
    }

    init() {
        Common.assets = p3.AssetManager.instance;
        Common.audio = p3.Button.audio = new AudioManager();
        Common.language = language;

        const params = new p3.ViewParams();
        params.holderId = "game";
        params.width = this._width;
        params.height = this._height;
        params.rotateImageUrl = "./assets/images/localisation/rotate_" + language + ".jpg";
        params.rotateImageColor = "#000000";

        PIXI.settings.RETINA_PREFIX = /\_(?=[^_]*$)(.+)x/;
        PIXI.settings.MIPMAP_TEXTURES = false;

        p3.Device.init(window["bowser"]);

        TweenMax.defaultOverwrite = "none";
        TweenMax.ticker.fps(60);

        const view = new p3.View(params);
        view.signals.ready.addOnce(function(canvas) {
            const options = {};
            options.view = canvas;
            options.transparent = false;
            options.antialias = false;
            options.preserveDrawingBuffer = false;
            options.resolution = 1.0;

            const stage = new PIXI.Container();
            Common.stage = stage;

            const input = new Input();
            input.init(stage, canvas);
            Common.input = input;

            if (p3.Device.isCocoonJS) {
                stage.scale.x = window.innerHeight / params.height;
                stage.scale.y = window.innerHeight / params.height;
            }

            const renderer = !p3.Device.isCocoonJS ?
                PIXI.autoDetectRenderer(this._width, this._height, options) :
                new PIXI.WebGLRenderer(window.innerWidth, window.innerHeight, options);
            renderer.backgroundColor = 0x0;
            Common.renderer = renderer;
            Common.isWebGL = (renderer instanceof PIXI.WebGLRenderer);

            const scene = new p3.SceneManager(renderer);
            scene.updateAll = true;
            Common.scene = scene;
            Common.stage.addChild(scene.view);

            // generate a blank texture
            const graphics = new PIXI.Graphics();
            graphics.beginFill(0xFFFFFF);
            graphics.drawRect(0, 0, 1, 1);
            graphics.endFill();
            Common.blankTexture = graphics.generateTexture();

            PIXI.ticker.shared.add(function(deltaTime) {
                //window.deltaTime = deltaTime / PIXI.settings.TARGET_FPMS / 1000;
                window.deltaTime = 1 / 60;

                scene.update();
                input.update();
                renderer.render(Common.stage);
            }, this);

            window.delay = function(callback, delay, scope) {
                return TweenMax.delayedCall(delay, callback, [], scope);
            };
            window.translate = function(str) {
                let s = Common.config.strings[str];
                s = s && s[Common.language];
                return (typeof s !== "undefined") ? s : str;
            };
            window.font = function(size, align) {
                align = align || "left";

                switch (language) {
                    case "tr" :
                    case "ro" :
                    case "pl" : {
                        size += 10;
                        if (size > 64) {
                            return {font: size + "px Cervo", align: align};
                        } else {
                            return {font: size + "px Cervo", align: align};
                        }
                    }
                    default : {
                        if (size > 64) {
                            return {font: size + "px Antique Olive Std", align: align};
                        } else {
                            return {font: size + "px Antique Olive Std", align: align};
                        }
                    }
                }
            };

            this.loadPreloader();
        }, this);
        view.signals.resize.add(this.onCanvasResize, this);
        Common.view = view;
    }

    loadPreloader() {
        const files = [
            {name: "characters", url: "data/" + "characters" + ".json"},
            {name: "strings", url: "data/" + "strings" + ".json"},

            {name: "preloader_1x", url: "images/" + "preloader_1x" + ".json"},

            {name: "antique_64", url: "fonts/" + "antique_64" + ".xml"},
            {name: "cervo_64", url: "fonts/" + "cervo_64" + ".xml"},
            {name: "noto_64", url: "fonts/" + "noto_64" + ".xml"},
        ];
        const sounds = [];
        if (files.length) {
            Common.assets.addFiles(files, "assets/");
            Common.assets.signals.complete.addOnce(function() {
                this.createConfig();
                this.loadAssets();
            }, this);
            Common.assets.load();
        } else {
            this.loadAssets();
        }
    }

    loadAssets() {
        const files = [
            {name: "track01", url: "data/tracks/" + "track01" + ".json"},
            {name: "track02", url: "data/tracks/" + "track02" + ".json"},
            {name: "track03", url: "data/tracks/" + "track03" + ".json"},
            {name: "track04", url: "data/tracks/" + "track04" + ".json"},
            {name: "track05", url: "data/tracks/" + "track05" + ".json"},

            {name: "vehicle_pussycat_1x", url: "images/" + "vehicle_pussycat_1x" + ".json"},
            {name: "vehicle_turbo_1x", url: "images/" + "vehicle_turbo_1x" + ".json"},
            {name: "vehicle_dastardly_1x", url: "images/" + "vehicle_dastardly_1x" + ".json"},
            {name: "vehicle_grusome_1x", url: "images/" + "vehicle_grusome_1x" + ".json"},
            {name: "vehicle_iq_1x", url: "images/" + "vehicle_iq_1x" + ".json"},

            {name: "ui_splash", url: "images/" + "ui_splash" + ".jpg"},
            {name: "ui_char_bg", url: "images/" + "ui_char_bg_1x" + ".jpg"},
            {name: "ui_loading", url: "images/" + "ui_loading" + ".jpg"},
            {name: "ui0_1x", url: "images/" + "ui0_1x" + ".json"},
            {name: "ui1_1x", url: "images/" + "ui1_1x" + ".json"},
            {name: "ui2_1x", url: "images/" + "ui2_1x" + ".json"},
            {name: "powerups_1x", url: "images/" + "powerups_1x" + ".json"},
            //{name: "logo", url: "images/localisation/" + "logo_" + language + ".png"},
            {name: "logo", url: "images/localisation/" + "logo_en" + ".png"},
            {name: "ui_tut_circle", url: "images/" + "ui_tut_circle" + ".png"},

            {name: "particle_emitter_missile_normal_trail", url: "particles/" + "particle_emitter_missile_normal_trail" + ".json"},
            {name: "particle_emitter_missile_smart_trail", url: "particles/" + "particle_emitter_missile_smart_trail" + ".json"},
            {name: "particle_emitter_powerup_butterflies", url: "particles/" + "particle_emitter_powerup_butterflies" + ".json"},
            {name: "particle_emitter_powerup_butterflies2", url: "particles/" + "particle_emitter_powerup_butterflies2" + ".json"},
            {name: "particle_emitter_powerup_bubbles", url: "particles/" + "particle_emitter_powerup_bubbles" + ".json"},
            {name: "particle_emitter_powerup_bubbles2", url: "particles/" + "particle_emitter_powerup_bubbles2" + ".json"},
            {name: "particle_emitter_glue_puddle_00", url: "particles/" + "particle_emitter_glue_puddle_00" + ".json"},
            {name: "particle_emitter_flameon_00", url: "particles/" + "particle_emitter_flameon_00" + ".json"},
            {name: "particle_emitter_lightning_speed_00", url: "particles/" + "particle_emitter_lightning_speed_00" + ".json"},
            {name: "particle_emitter_powerup_steamahead", url: "particles/" + "particle_emitter_powerup_steamahead" + ".json"},
            {name: "particle_emitter_offtrack_dust_00", url: "particles/" + "particle_emitter_offtrack_dust_00" + ".json"},
            {name: "particle_emitter_explosion_00", url: "particles/" + "particle_emitter_explosion_00" + ".json"},
            {name: "particle_emitter_impact_left_00", url: "particles/" + "particle_emitter_impact_left_00" + ".json"},
            {name: "particle_emitter_impact_right_00", url: "particles/" + "particle_emitter_impact_right_00" + ".json"},
            {name: "particle_emitter_candy_blast_00", url: "particles/" + "particle_emitter_candy_blast_00" + ".json"},
            {name: "particle_emitter_trophy_stars_00", url: "particles/" + "particle_emitter_trophy_stars_00" + ".json"},
        ];
        const sounds = [
            "sfx_btn_press_00",
            "sfx_btn_rollover_00",
            "sfx_btn_nextcar_00",
            "sfx_car_land_00",
            "sfx_whistle_rise_00",
            "sfx_whistle_fall_00",
            "sfx_crowd_cheer_00",
            "sfx_fanfare_00",
            "sfx_carsrush_by_00",
            "sfx_cockerel_cry_00",
            "sfx_change_race_position_00",
            "ui_tracks_poster_reveal_00",

            "sfx_car_hit_00",
            "sfx_car_hit_01",
            "sfx_car_hit_02",
            "sfx_car_hit_03",
            "sfx_car_hit_04",
            "sfx_car_hit_05",
            "sfx_car_hit_06",
            "sfx_car_hit_07",
            "sfx_car_hit_08",
            "sfx_car_hit_09",
            "sfx_car_hit_10",
            "sfx_generic_race_loop_00",
            "sfx_generic_race_loop_01",
            "sfx_generic_race_loop_02",
            "sfx_ambient_wacky_loop_03",
            "sfx_trigger_switch_00",
            "sfx_carhorn_00",
            "sfx_carhorn_01",
            "sfx_carhorn_02",
            "sfx_carhorn_03",
            "sfx_crate_open_squeak_00",
            "sfx_muttly_giggle_00",
            "sfx_offtrack_loop_00",

            "sfx_pussycat_loop_01",
            "sfx_turbo_loop_00",
            "sfx_grusome_loop_01",
            "sfx_dastardly_loop_00",
            "sfx_iq_loop_01",

            "music_intro_start_00",
            "music_intro_loop_00",
            "music_intro_end_00",
            "music_garage_loop_00",
            "music_raceloop_00",
            "music_raceloop_01",
            "music_raceloop_02",
            "music_race_end_00",

            "sfx_race_lights_count_00",
            "sfx_race_lights_go_00",
            "sfx_car_start_tyres_04",
            "sfx_race_start_idle_revs_00",
            "sfx_hit_gravel_00",
            "sfx_hit_gravel_01",
            "sfx_hit_gravel_02",

            "sfx_bomb_explode_big_00",
            "sfx_bomb_explode_big_01",
            "sfx_launch_glue_00",
            "sfx_hit_glue_00",
            "sfx_launch_glue_00",
            "sfx_launch_missile_00",
            "sfx_launch_missile_01",
            "sfx_launch_object_00",
            "sfx_launch_object_01",
            "sfx_launch_object_02",
            "sfx_launch_object_03",
            "sfx_launch_object_04",
            "sfx_launch_object_05",
            "sfx_pickup_powerup_crate_00",
            "sfx_powerup_selected_00",
            "sfx_powerup_speedup_tyre_screech_00",
            "sfx_powerup_randomiser_loop_00",
            "sfx_car_slowdown_skid_00",
            "sfx_powerup_bubbles_00",
            "sfx_powerup_butterflies_01",
            "sfx_powerup_flame_00",
            "sfx_powerup_lightning_01",
            "sfx_powerup_steam_01",
            "sfx_hit_candy_02",
            "sfx_powerup_candy_00"
        ];
        if (files.length) {
            this._preloader = new BoomerangPreloaderScene();
            Common.scene.add(this._preloader);

            Common.assets.addFiles(files, "assets/");
            Common.assets.signals.progress.add(this.onLoadingProgress, this);
            Common.assets.signals.complete.addOnce(this.onLoadingCompleted, this);
            Common.assets.load();

            //Common.audio.addSoundSprite("sprite", sprite, [".ac3", ".m4a", ".mp3", ".ogg"], "assets/audio/");
            Common.audio.addSounds(sounds, [".m4a", ".mp3", ".ogg"], "assets/audio/");
        } else {
            this.startGame();
        }
    }

    createConfig() {
        const assets = Common.assets;

        const config = {};
        config.characters = assets.getJSON("characters").characters;
        config.strings = assets.getJSON("strings");
        Common.config = config;
        console.log(config);
    }

    startGame() {
        delay(function() {
            this._game = new Application();
            this._game.init();
        }, 1.0, this);
    }

    /**
     * @param {Event} event
     */
    onLoadingProgress(event) {
        this._preloader.loaded = event.progress / 100.0;
    }

    onLoadingCompleted() {
        Common.assets.signals.progress.removeAll();
        Common.assets.signals.complete.removeAll();

        this._preloader.loaded = 1;
        this.startGame();
    }

    /**
     * @param {boolean} correct
     */
    onCanvasResize(correct) {
        if (correct) {
            Common.renderer.resize(p3.View.width, p3.View.height);
            if (Common.scene) {
                Common.scene.resize();
            }
        }
    }
}
